import React, { Component } from "react";
import logo from "../../assets/images/ToyotaLogo.jpg";
import { Link, Redirect } from "react-router-dom";
import "./header.css";
import { userActions } from "../../actions/index.js";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import { withRouter } from "react-router-dom";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      emailPreference: this.props.emailPreference,
      emailAddress: this.props.NmscEmailIds,
      showEmailError:
        this.props.emailPreference !== 0 &&
        this.props.emailPreference !== null &&
        this.props.NmscEmailIds === "",
      showZipSize: true,
      defaultValue: this.props.emailPreference,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handlePreference = this.handlePreference.bind(this);
    this.changeEmailPreference = this.changeEmailPreference.bind(this);
  }

  changeEmailPreference(event) {
    console.log("events=", event);
    const { name, id } = event.target;
    console.log("name:", name, "id:", id);
    if (id == "flexRadioDefault1") {
      this.setState({ emailPreference: 0, showEmailError: false });
    } else if (id == "flexRadioDefault2") {
      if (
        this.state.emailAddress.length === 0 ||
        this.state.emailAddress === ""
      ) {
        this.setState({ showEmailError: true });
      } else {
        this.setState({ showEmailError: false });
      }
      this.setState({ emailPreference: 1 });
    } else if (id == "flexRadioDefault3") {
      if (
        this.state.emailAddress.length === 0 ||
        this.state.emailAddress === ""
      ) {
        this.setState({ showEmailError: true });
      } else {
        this.setState({ showEmailError: false });
      }
      this.setState({ emailPreference: 2 });
    }
  }

  handleClose() {
    this.setState({
      emailPreference: this.state.defaultValue,
      show: false,
      showEmailError:
        this.state.defaultValue != 0 &&
        this.state.defaultValue != null &&
        this.state.emailAddress === "",
    });
  }
  handlePreference() {
    this.props.setEmailPreference(this.state.emailPreference);

    this.setState({ defaultValue: this.state.emailPreference, show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }
  render() {
    console.log("props=", this.props);
    console.log("Email Functionality is also added in this code");
    const emailError =
      "There is no e-mail setup with TME. Kindly contact TME Customer Support.";
    const zipSizeNote =
      "(within the maximum attachment size limitation of 8 MB)";
    return (
      <div className="headbar">
        <div className="row">
          <div className="col-md-2 col-sm-3 col-xs-3">
            <img
              src={logo}
              alt=""
              style={{ top: "10px", position: "absolute", width: "44%" }}
            />
          </div>
          <div
            className="col-md-4 col-sm-1 col-xs-1"
            style={{ textAlign: "left", height: "3rem" }}
          >
            <h2
              className="labelmargintop"
              style={{ fontSize: "150%", color: "#428bca" }}
            >
              TME Value Chain Document Store
            </h2>
          </div>
          <div
            className="col-md-2 col-sm-2 col-xs-3"
            style={{ marginTop: "10px", textAlign: "left" }}
          >
            <span
              style={{
                position: "relative",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              {this.props.username}
            </span>
          </div>

          <div
            className="col-md-1 col-sm-2 col-xs-1 labelmargintop"
            style={{ textAlign: "left" }}
          >
            {this.props.roles.includes("EDOC TRD USER") ||
            this.props.roles.includes("EDOC NMSC TRD USER") ||
            this.props.roles.includes("EDOC TME AF USER") ? (
              <Link to="/search">
                <span style={{ color: "white" }}>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      marginLeft: "90px",
                      height: "2.9rem",
                    }}
                  >
                    Shipment
                  </button>
                </span>
              </Link>
            ) : this.props.roles.includes("EDOC INVOICE ADMIN") ? (
              <Link to="/auditorAdmin">
                <span>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      marginLeft: "90px",
                      height: "2.9rem",
                    }}
                  >
                    Auditor Setup
                  </button>
                </span>
              </Link>
            ) : null}
          </div>

          <div
            className="col-md-1 col-sm-2 col-xs-1 labelmargintop"
            style={{ textAlign: "left" }}
          >
            {this.props.roles.includes("EDOC TME AF USER") ||
            this.props.roles.includes("EDOC VLG TME USER") ||
            this.props.roles.includes("EDOC VLG NMSC USER") ? (
              <div>
                {" "}
                <Link to="/salesInvoice">
                  <span style={{ color: "white" }}>
                    <button
                      className="btn btn-danger btn-circle pull-right"
                      style={{
                        marginTop: "10px",
                        marginLeft: "90px",
                        height: "2.9rem",
                      }}
                    >
                      Vehicle Sales
                    </button>
                  </span>
                </Link>
              </div>
            ) : null}
          </div>

          <div
            className="col-md-1 col-sm-2 col-xs-1 labelmargintop"
            style={{ textAlign: "left" }}
          >
            {this.props.roles.includes("EDOC PSCG ADMIN") ? (
              <Link to="/pscgInvoicingSystem">
                <span style={{ color: "white" }}>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      marginLeft: "90px",
                      height: "2.9rem",
                    }}
                  >
                    TME ADMIN
                  </button>
                </span>
              </Link>
            ) : (
              <div>
                {this.props.roles.includes("EDOC NMSC USER") ? (
                  <div>
                    <span style={{ color: "white" }}>
                      <button
                        className="btn btn-danger btn-circle pull-right"
                        onClick={this.handleShow}
                        style={{
                          marginTop: "10px",
                          marginLeft: "90px",
                          height: "2.9rem",
                        }}
                      >
                        Email Preference
                      </button>
                    </span>
                  </div>
                ) : null}
              </div>
            )}
          </div>
          <div
            className="col-md-1 col-sm-2 col-xs-2 labelmargintop"
            style={{ textAlign: "left" }}
          >
            <button
              className="btn btn-danger btn-circle"
              style={{ marginTop: "10px", height: "2.9rem" }}
              onClick={this.props.logoutUser}
            >
              <i
                className="fa fa-sign-out"
                aria-hidden="true"
                style={{ marginLeft: "1px" }}
              ></i>
              LogOut
            </button>
          </div>
        </div>
        <Modal
          size="lg"
          show={this.state.show}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>
              <div>Email Notification Preference</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span className="createBox">
              <div>
                <div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      //onChange={() => this.setState({ emailPreference: 0 })}
                      onChange={this.changeEmailPreference}
                      checked={
                        this.state.emailPreference == 0 ||
                        this.state.emailPreference === null
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      I do not want e-mail notifications
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      checked={this.state.emailPreference == 1}
                      //onChange={() => this.setState({ emailPreference: 1 })}
                      onChange={this.changeEmailPreference}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault2"
                    >
                      I want e-mail notification with a link to eDoc
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault3"
                      checked={this.state.emailPreference == 2}
                      //onChange={() => this.setState({ emailPreference: 2 })}
                      onChange={this.changeEmailPreference}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault3"
                    >
                      I want e-mail notification with invoice as PDF attachment.
                    </label>
                    {this.state.showZipSize ? (
                      <div style={{ fontSize: "small" }}>{zipSizeNote}</div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
            </span>
          </Modal.Body>
          <Modal.Footer
            style={{
              justifyContent: "space-between",
            }}
          >
            {this.state.showEmailError ? (
              <Alert
                key="danger"
                variant="danger"
                className="nmscEmailError"
                style={{
                  marginRight: "3.5rem",
                }}
              >
                {" "}
                {emailError}
              </Alert>
            ) : (
              <Alert
                key="success"
                variant="success"
                className="nmscEmailError"
                style={{
                  marginRight: "3.5rem",
                  visibility:
                    this.state.emailPreference == 0 ||
                    this.state.emailPreference == null
                      ? "hidden"
                      : "initial",
                }}
              >
                {" "}
                {`Email Provided - ${this.state.emailAddress}`}
              </Alert>
            )}

            <div>
              <button
                className="btn btn-primary"
                type="button"
                disabled={this.state.showEmailError}
                onClick={this.handlePreference}
                style={{
                  display:
                    this.state.emailPreference === null ? "none" : "initial",
                  // borderRadius: "20px",
                  // backgroundColor: "#E50000",
                  height: "39px",
                }}
              >
                {"Save"}
              </button>{" "}
              &nbsp;&nbsp;&nbsp;
              <input
                type="button"
                className="btn btn-primary"
                value="Cancel"
                onClick={this.handleClose}
                style={{
                  //borderRadius: "20px",
                  //backgroundColor: "#E50000",
                  //color: "white",
                  height: "39px",
                }}
              />
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(mapStateToProps)(Header));
